import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataProcessingService } from './data-prcessing.service';
import { Banner } from '../interfaces/banner.interface';
import { GenericResponseWithTotal } from '../interfaces/generic.interface';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoggerService } from './logger.service';
import { Camapign, CardStatisticsResponse } from '../interfaces/campaigns.interface';


@Injectable({
  providedIn: 'root'
})
export class CamapignService {
  private get apiUrl(): string {
    return this.loggerService.resolveApiUrl('campaign');
  }

  constructor(
    private http: HttpClient,
    private dataProcess: DataProcessingService,
    private loggerService: LoggerService
  ) { }

  getPartnersCamaigns(params?: any): Observable<GenericResponseWithTotal<Camapign>> {
    params = params || {};
    return this.http.get<GenericResponseWithTotal<Camapign>>(this.apiUrl, { 
      params: this.dataProcess.fitlerParams(params) 
    });
  }

  getCamapignById(id: number): Observable<Camapign> {
    return this.http.get<Camapign>(`${this.apiUrl}/${id}`);
  }


  createCamapign(data: Partial<Camapign>): Observable<Camapign> {
    return this.http.post<Camapign>(this.apiUrl, data);
  }

  updateCamapign(campaign_id: number,  data: Partial<Camapign>): Observable<Camapign> {
    return this.http.put<Camapign>(this.apiUrl + '/' + campaign_id, data);
  }

  getCurrentList(params?: any): Observable<GenericResponseWithTotal<Camapign>> {
    params = params || {};
    return this.http.get<GenericResponseWithTotal<Camapign>>(`${this.apiUrl}/current/list`, {
      params: this.dataProcess.fitlerParams(params)
    });
  }


}
